import { render, staticRenderFns } from "./AbrirCaixaModal.vue?vue&type=template&id=37abc78c&scoped=true"
import script from "./AbrirCaixaModal.vue?vue&type=script&lang=js"
export * from "./AbrirCaixaModal.vue?vue&type=script&lang=js"
import style0 from "./AbrirCaixaModal.vue?vue&type=style&index=0&id=37abc78c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37abc78c",
  null
  
)

export default component.exports